module.exports = __webpack_public_path__ + "static/media/icon_failed-stages-issue.d30abbb3.svg";